'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwToggle = require('./CwToggle.scss');

var _CwToggle2 = _interopRequireDefault(_CwToggle);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwToggle = function CwToggle(props) {
  var handleClick = function handleClick() {
    if (props.disabled || !props.onChange) {
      return;
    }

    props.onChange(!props.value);
  };

  var handleKeyPress = function handleKeyPress(event) {
    if (props.disabled || !props.onChange || event.which !== 32) {
      return;
    }

    event.preventDefault();
    props.onChange(!props.value);
  };

  return _react2.default.createElement(
    'div',
    {
      'data-cwid': props.cwId,
      className: (0, _classnames2.default)(_CwToggle2.default.wrap, props.className, (0, _defineProperty3.default)({}, _CwToggle2.default.disabled, props.disabled)),
      tabIndex: props.disabled ? -1 : props.tabIndex,
      onKeyPress: handleKeyPress,
      onFocus: props.onFocus,
      onBlur: props.onBlur,
      onClick: handleClick,
      style: props.style },
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_CwToggle2.default.toggle, props.value ? _CwToggle2.default.toggleChecked : _CwToggle2.default.toggleUnchecked) }),
    props.text ? _react2.default.createElement(
      'label',
      { className: _CwToggle2.default.label },
      props.text
    ) : null
  );
};

CwToggle.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Text next to checkbox
   */
  text: _propTypes2.default.string,
  /**
   * Callback function when checkbox value is changed
   */
  onChange: _propTypes2.default.func,
  /**
   * Used to check a checkbox
   */
  value: _propTypes2.default.bool,
  /**
   * Can be used to disable checkbox
   */
  disabled: _propTypes2.default.bool,
  /**
   * Used to control tab order
   */
  tabIndex: _propTypes2.default.number,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes2.default.func,
  /**
   * Override the styles of the root element
   */
  style: _propTypes2.default.object,
  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes2.default.string
};

CwToggle.defaultProps = {
  tabIndex: 0
};

exports.default = CwToggle;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwtoggle/CwToggle.js
// module id = 861
// module chunks = 10